import { Box, Checkbox, CircularProgress, IconButton, Modal, Paper, Typography } from '@mui/material';
import { CloseIcon } from 'assets/icons';
import { FC, Fragment, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'shared/lib/hooks/hooks';
import { serverURL } from 'shared/lib/serverURL';

interface IOfferAgreementProps {

}

const OfferAgreement: FC<IOfferAgreementProps> = () => {
  const { t } = useTranslation();
  const [publicOffer, setPublicOffer] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);

  const { control } = useFormContext();

  const Offer = useAppSelector(
    (state) => state.offerAgreements.marathonAgreementById.data
  );
  const offerLoading = useAppSelector(
    (state) => state.offerAgreements.marathonAgreementById.loading
  );

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Controller
          name="offerAccepted"
          control={control}
          rules={{ required: t('registerToMarathon.rulesMustBeAccepted') }}
          render={({ field, fieldState }) => (
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Box display="flex" alignItems="center" gap={1}>
                <Checkbox
                  {...field}
                  checked={field.value}
                  sx={{ p: 0, ml: 1.3, '& .MuiSvgIcon-root': { fontSize: 24 } }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: 14, sm: 16 },
                    lineHeight: 1.5,
                  }}
                >
                  {t("myMarathon.rulesOfParticipationAccepted")
                    .split("{0}")
                    .map((part, i, arr) => (
                      <Fragment key={i}>
                        {part}
                        {i < arr.length - 1 && (
                          <Box
                            component="span"
                            onClick={() => setPublicOffer(true)}
                            sx={{
                              color: 'primary.main',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              ml: 0.5,
                            }}
                          >
                            {t("myMarathon.rulesOfParticipation")}
                          </Box>
                        )}
                      </Fragment>
                    ))}
                </Typography>
              </Box>

              {fieldState.error && (
                <Typography color="error" variant="body2" sx={{ ml: 5 }}>
                  {fieldState.error.message}
                </Typography>
              )}
            </Box>
          )}
        />
      </Box>

      <Modal
        open={publicOffer}
        onClose={() => setPublicOffer(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Paper
          sx={{
            position: 'relative',
            width: { xs: '95%', sm: '80%', md: '60%' },
            height: { xs: '80%', sm: '80%', md: '80%' },
            borderRadius: 2,
            p: 6,
            boxShadow: 24,
          }}
        >
          <IconButton
            onClick={() => setPublicOffer(false)}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          {offerLoading ? (
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            serverURL && Offer?.documentPath && (
              <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                {iframeLoading && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(255,255,255,0.7)',
                      zIndex: 1,
                    }}
                  >
                    <CircularProgress />
                  </Box>
                )}

                <iframe
                  title="PublicOfferFrame"
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(serverURL + Offer.documentPath)}&embedded=true`}
                  style={{ width: '100%', height: '100%', border: 'none', borderRadius: 8 }}
                  onLoad={() => setIframeLoading(false)}
                />
              </Box>
            )
          )}
        </Paper>
      </Modal>
    </Paper>
  );
};

export default OfferAgreement;
